import { css, cx } from '@lastbrand/web-ui-styled-system/css'

import * as styles from './product-info-price-ds.styles'

export interface EarnCreditFestivalTagProps {
  earnCreditTagFor3PVendor?: string
  pdpPriceRedesign?: boolean
}

// Earn-credit tag beside the festival offer value (left-margin variant).
// The no-festival earn-credit tag lives in MainPriceColumn.
function EarnCreditFestivalTag({ earnCreditTagFor3PVendor, pdpPriceRedesign }: EarnCreditFestivalTagProps) {
  return (
    <div
      className={cx(
        // Single css() so `ml` resolves once: cx()-stacking base (space-8) and the left-margin
        // variant (space-4) leaves order to Panda's stylesheet scan, not cx args.
        css({
          paddingBlock: 'space-4',
          paddingInline: 'space-6',
          textStyle: 'body-12',
          fontFamily: 'Grosa, ui-sans-serif, system-ui, sans-serif',
          fontWeight: 400,
          background: 'cantaloupe-80',
          backdropFilter: 'blur(2px)',
          ml: 'space-4',
        }),
        pdpPriceRedesign && styles.priceWrapperMainEarnCreditTagRegularWeightCss,
      )}
    >
      {earnCreditTagFor3PVendor}
    </div>
  )
}

export default EarnCreditFestivalTag
